import { Extension } from "@tiptap/core"
import { Plugin, PluginKey } from "@tiptap/pm/state"
import { textContainsPromptTokens, textToDoc, trimTrailingEmptyParagraphs } from "./serialize"
import type { MentionItem } from "./types"

export type TokenPasteOptions = {
  getItems: () => MentionItem[]
}

/**
 * Paste text/plain с токенами (@hero[…] и т.д.) → mention-чипы.
 * Приоритет над HTML, чтобы кросс-вкладка стабильно поднимала разметку.
 */
export const TokenPaste = Extension.create<TokenPasteOptions>({
  name: "tokenPaste",

  addOptions() {
    return {
      getItems: () => [],
    }
  },

  addProseMirrorPlugins() {
    const editor = this.editor
    const getItems = () => this.options.getItems()

    return [
      new Plugin({
        key: new PluginKey("tokenPaste"),
        props: {
          handlePaste(_view, event) {
            const text = event.clipboardData?.getData("text/plain")
            if (!text || !textContainsPromptTokens(text)) return false

            event.preventDefault()
            const doc = textToDoc(text, getItems())
            const content = trimTrailingEmptyParagraphs(doc.content ?? [])
            if (content.length === 1 && content[0]?.type === "paragraph") {
              editor.commands.insertContent(content[0].content ?? [])
            } else {
              editor.commands.insertContent(content)
            }
            return true
          },
        },
      }),
    ]
  },
})
